module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    class: {
      'login--highlighted': _vm.shouldShowPasswordField, 'login--failed': _vm.hasFailureMsg
    }
  }, [_c('email-input', {
    attrs: {
      "disabled": _vm.value.loggedIn,
      "loading": _vm.loading
    },
    on: {
      "input": _vm.emailInput
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  }), _vm._v(" "), (_vm.value.loggedIn) ? _c('div', {
    staticClass: "logout-btn"
  }, [_vm._v("\n      Not you? "), _c('span', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Log Out")])]) : _vm._e(), _vm._v(" "), (_vm.shouldShowPasswordField) ? _c('fieldset', [_c('input-with-validation', {
    attrs: {
      "type": "password",
      "label": "Password",
      "login-on-enter": "true"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasFailureMsg),
      expression: "hasFailureMsg"
    }],
    staticClass: "login__failure-msg",
    domProps: {
      "innerHTML": _vm._s(_vm.failureMsg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login__buttons flex gutter"
  }, [_c('button', {
    staticClass: "button button--primary",
    class: {
      'btn--disabled': _vm.loginBtnDisabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.attemptLogin
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('button', {
    staticClass: "button button--primary-alternate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.continueAsGuest($event)
      }
    }
  }, [_vm._v("Continue as Guest")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51aa5e49","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userLogin.vue
// module id = 600
// module chunks = 0